import { api } from "api/common";
import { createActionsHook } from "react-redux-actions-hook";
import { setToastMessage, setBusy } from "../app/actions";
import { AuthActionType } from "./constants";
import {
  USER_LOGIN_URL,
  GOOGLE_LOGIN_URL,
  USER_REGISTER_URL,
  ME_USER_URL,
  USER_LOGOUT_URL,
  PROCESS_INVITE,
  CHECK_INVITE,
  LOAD_INVITE,
  RESET_PASSWORD,
  REQUEST_RESET_PWD,
} from "api/constants";
import { AppRouteURI } from "../../router/RoleBasedAccess";
import { push } from "connected-react-router";

export const setAuthState = (loggedIn) => {
  return { type: AuthActionType.SET_AUTH, loggedIn };
};

export const setRole = ({ role }) => {
  return { type: AuthActionType.SET_ROLE, role };
};

export const setGuser = ({ role }) => {
  return { type: AuthActionType.SET_GUSER, role };
};

export const setRegistration = (register) => {
  return { type: AuthActionType.SET_REGISTRATION, register };
};

export const setInviteData = (data) => {
  return { type: AuthActionType.SET_INVITE_DATA, data };
};

export const login = (email, password) => {
  return (dispatch) => {
    api(
      USER_LOGIN_URL,
      {
        method: "POST",
        body: JSON.stringify({ email, password }),
      },
      dispatch
    )
      .then(() => {
        dispatch(loadMe());
        dispatch(setAuthState(true));
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

export const googleLogin = (data) => {
  return (dispatch) => {
    api(
      GOOGLE_LOGIN_URL,
      {
        method: "POST",
        body: JSON.stringify(data),
      },
      dispatch
    )
      .then((data) => {
        dispatch(loadMe());
        dispatch(setAuthState(data.isLoggedIn));
        dispatch(setGuser(true));
        dispatch(
          setToastMessage({
            message: "Logged in through google successfully",
            type: "success",
          })
        );
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

export const register = (registrationInfo) => {
  const data = { ...registrationInfo };
  delete data["role"];
  return (dispatch) => {
    api(
      USER_REGISTER_URL,
      {
        method: "POST",
        body: JSON.stringify(data),
      },
      dispatch
    )
      .then(() => {
        dispatch(
          setToastMessage({
            message: "Successfully registered",
            type: "success",
          })
        );
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

export const processInvite = (data) => {
  return (dispatch, stateFn) => {
    const { query } = stateFn().router.location;
    api(
      PROCESS_INVITE,
      {
        method: "POST",
        body: JSON.stringify({ ...data, ...query }),
      },
      dispatch
    )
      .then(() => {
        dispatch(
          setToastMessage({
            message: "Successfully registered",
            type: "success",
          })
        );
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

export const loadMe = () => {
  return (dispatch) => {
    dispatch(setBusy(true));
    api(ME_USER_URL, {}, dispatch)
      .then((data) => {
        dispatch(setBusy(false));
        dispatch(setAuthState(data.isLoggedIn));
        dispatch(setRole(data));
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

export const logout = () => {
  return (dispatch) => {
    api(USER_LOGOUT_URL, {}, dispatch)
      .then((data) => {
        dispatch(setAuthState(data.isLoggedIn));
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

export const checkInvite = () => {
  return (dispatch, stateFn) => {
    const { location } = stateFn().router;
    const token = location["query"]["token"];
    api(
      CHECK_INVITE,
      {
        method: "POST",
        body: JSON.stringify({ token }),
      },
      dispatch
    )
      .then((res) => {
        dispatch(
          setToastMessage({
            message: res.message,
            type: "success",
          })
        );
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Invalid Invite",
            type: "error",
          })
        );
      });
  };
};

export const loadInviteDetails = () => {
  return (dispatch, stateFn) => {
    const { location } = stateFn().router;
    const token = location["query"]["token"];
    if (!token) {
      dispatch(push(AppRouteURI.HOME));
    }
    api(
      `${LOAD_INVITE}/${token}`,
      {
        method: "GET",
      },
      dispatch
    )
      .then(({ data }) => {
        dispatch(setInviteData(data));
      })
      .catch((error) => {
        dispatch(push(AppRouteURI.HOME));
      });
  };
};

export const resetPasswordWithToken = (new_password) => {
  return (dispatch, stateFn) => {
    const { location } = stateFn().router;
    const token = location["query"]["token"];
    if (!token) {
      dispatch(push(AppRouteURI.HOME));
    }
    api(
      `${RESET_PASSWORD}`,
      {
        method: "POST",
        body: JSON.stringify({ token, new_password }),
      },
      dispatch
    )
      .then((res) => {
        dispatch(
          setToastMessage({
            message: res.message || "Reset Successful",
            type: "success",
          })
        );
      })
      .catch((error) => {});
  };
};

export const requestResetPassword = (email) => {
  return (dispatch) => {
    api(
      `${REQUEST_RESET_PWD}/${email}`,
      {
        method: "POST",
      },
      dispatch
    )
      .then((res) => {
        dispatch(
          setToastMessage({
            message: res.message || "Email Sent",
            type: "success",
          })
        );
      })
      .catch((error) => {});
  };
};

export default createActionsHook({
  loadMe,
  logout,
  register,
  googleLogin,
  login,
  processInvite,
  setRegistration,
  checkInvite,
  loadInviteDetails,
  resetPasswordWithToken,
  requestResetPassword,
});
